exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-category-desc[data-v-3a975b25] {\n  color: #707070;\n}\n.tab-category-desc[data-v-3a975b25] h2 {\n  font-size: 20px;\n}\n.tab-category-desc[data-v-3a975b25] p {\n  font-size: 16px;\n}\n.tabDescription[data-v-3a975b25] h2 {\n  font-size: 22px;\n}\n", ""]);

// exports
